import "core-js/modules/esnext.iterator.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/modelCode-oem.svg';
import _imports_1 from '@/assets/image/sn-oem.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-35f126a4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "activation-success-header"
};
var _hoisted_2 = {
  key: 0,
  class: "activation-success-header-wrapper"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "activation-success-header-title"
};
var _hoisted_5 = {
  class: "activation-success-header-des"
};
var _hoisted_6 = {
  key: 1,
  class: "activation-success-header-wrapper is-oem"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "oem-title"
};
var _hoisted_9 = {
  class: "oem-des"
};
var _hoisted_10 = {
  key: 0,
  class: "activation-product"
};
var _hoisted_11 = {
  class: "activation-product-item"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "activation-product-item-title"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_15 = {
  class: "activation-product-item-num"
};
var _hoisted_16 = {
  class: "activation-product-item-title"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_18 = {
  class: "activation-product-item-num"
};
var _hoisted_19 = {
  key: 1,
  class: "activation-success-content"
};
var _hoisted_20 = {
  key: 2,
  class: "activation-success-footer"
};
var _hoisted_21 = ["src"];
var _hoisted_22 = ["href"];
var _hoisted_23 = {
  class: "activation-success-footer-des"
};
import { useDirectionalLang } from '@/hooks/directionalLang';
import { useStore } from 'vuex';
export default {
  props: {
    sn: {
      type: String
    },
    modelCode: {
      type: String
    },
    dlpImgUrl: {
      type: String
    },
    isOem: {
      type: Boolean,
      default: false
    },
    langkey: {
      type: String,
      default: 'zh_CN'
    }
  },
  setup: function setup(__props) {
    var _$store$state;
    var props = __props;
    var $store = useStore();
    var _useDirectionalLang = useDirectionalLang(props.langkey),
      $t = _useDirectionalLang.$t;
    var _$store$state$global = (_$store$state = $store.state) === null || _$store$state === void 0 ? void 0 : _$store$state.global,
      qrCode = _$store$state$global.qrCode;
    var _ref = qrCode || {},
      authorizationUrl = _ref.authorizationUrl,
      cn = _ref.cn,
      en = _ref.en;
    var isCN = props.langkey.includes('CN');
    var qrCodeList = ref([]);
    if (isCN) {
      qrCodeList.value = cn === null || cn === void 0 ? void 0 : cn.map(function (val) {
        return {
          name: val === null || val === void 0 ? void 0 : val.name,
          url: "".concat(authorizationUrl).concat(val === null || val === void 0 ? void 0 : val.url)
        };
      });
    } else {
      qrCodeList.value = en;
    }

    // const qrCodeList = ref([
    //     { name: $t( 'activation.h5.gongzhonghao' ), url: require( '@/assets/image/dental/gongzhonghao.png' ) },
    //     { name: $t( 'activation.h5.shipinhao' ), url: require( '@/assets/image/dental/shipinhao.png' ) },
    //     { name: $t( 'activation.h5.douyin' ), url: require( '@/assets/image/dental/douyin.png' ) }
    // ]);

    // const enList = ref([
    //     { name: 'icon-Facebook', url: 'https://www.facebook.com/shining3d.dental' },
    //     { name: 'icon-LinkedIn', url: 'https://www.linkedin.com/showcase/shining3d-dental/' },
    //     { name: 'icon-YouTube', url: 'https://www.youtube.com/c/SHINING3DDental' },
    //     { name: 'icon-Instagram', url: 'https://www.instagram.com/shining3ddental/' }
    // ]);

    return function (_ctx, _cache) {
      var _component_van_divider = _resolveComponent("van-divider");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["activation-success", __props.isOem ? 'is-oem' : ''])
      }, [_createElementVNode("div", _hoisted_1, [!__props.isOem ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        src: require('@/assets/image/success.svg'),
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($t)('activation.h5.activateSuccess')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('activation.h5.deviceNum')) + " " + _toDisplayString(__props.sn), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
        src: require('@/assets/image/success-oem.svg'),
        alt: ""
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('activation.h5.activateSuccess')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('activation.h5.useDevNormal')), 1)]))]), __props.isOem ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        class: "activation-product-item-img",
        src: __props.dlpImgUrl,
        alt: ""
      }, null, 8, _hoisted_12), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_13, [_hoisted_14, _createTextVNode(" " + _toDisplayString(_unref($t)('activation.h5.modelCode')), 1)]), _createElementVNode("span", _hoisted_15, _toDisplayString(__props.modelCode), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_16, [_hoisted_17, _createTextVNode(" " + _toDisplayString(_unref($t)('activation.h5.sn')), 1)]), _createElementVNode("span", _hoisted_18, _toDisplayString(__props.sn), 1)])])])])) : _createCommentVNode("", true), !__props.isOem ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString(_unref($t)('activation.h5.useDevNormal')), 1), _createElementVNode("div", null, _toDisplayString(_unref($t)('activation.h5.getMoreTip')), 1)])) : _createCommentVNode("", true), !__props.isOem ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_van_divider, null, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)('activation.h5.getMore')), 1)];
        }),
        _: 1
      }), _createElementVNode("ul", {
        class: _normalizeClass(_unref(isCN) ? 'activation-success-footer-qrCodes' : 'activation-success-footer-enLink')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qrCodeList.value, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.name
        }, [_unref(isCN) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          src: item.url,
          alt: ""
        }, null, 8, _hoisted_21), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 64)) : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: item.url
        }, [_createElementVNode("i", {
          class: _normalizeClass(["iconfont", item.name])
        }, null, 2)], 8, _hoisted_22))]);
      }), 128))], 2), _createElementVNode("div", _hoisted_23, _toDisplayString(_unref($t)('activation.h5.logoTip')), 1)])) : _createCommentVNode("", true)], 2);
    };
  }
};